// Italian (it)
export default {
  // --- Shell / nav ---
  app_name: 'Maree nei dintorni',
  search_stations: 'Cerca stazioni',
  search_stations_hint: 'Cerca stazioni (⌘K)',
  settings: 'Impostazioni',
  app_store: 'Scarica su App Store',
  google_play: 'Scaricala su Google Play',
  app_promo_title: "Scarica l'app gratuita. È più veloce 🙂",
  app_promo_body: 'Le stesse previsioni di maree e correnti, sul tuo telefono.',
  privacy: 'Privacy',
  terms: 'Termini',
  data_sources: 'Fonti dei dati',
  support: 'Supporto',

  guides: 'Guide',
  // --- Home ---
  home_title: 'Trova maree e correnti nelle vicinanze',
  by_country: 'Per paese',
  favorite_tides: 'Maree preferite',
  recent_tides: 'Maree recenti',
  nearby_tides: 'Maree nei dintorni',
  favorite_currents: 'Correnti preferite',
  recent_currents: 'Correnti recenti',
  nearby_currents: 'Correnti nei dintorni',
  favorite_charts: 'Carte nautiche preferite',
  recent_charts: 'Carte nautiche recenti',
  nearby_charts: 'Carte nautiche nei dintorni',
  finding_stations: 'Ricerca di stazioni vicino a te…',
  distance_away: 'A {{distance}}',

  // --- Search overlay ---
  search_placeholder: 'Cerca stazioni…',
  tide_stations: 'Stazioni mareografiche',
  current_stations: 'Stazioni di corrente',
  recents: 'Recenti',
  search_unavailable: 'La ricerca non è disponibile al momento.',
  no_stations_found: 'Nessuna stazione trovata.',
  search_prompt: 'Cerca stazioni di marea e di corrente per nome.',

  // --- Settings ---
  appearance: 'Aspetto',
  appearance_system: 'Sistema',
  appearance_light: 'Chiaro',
  appearance_dark: 'Scuro',
  tide_height: 'Altezza di marea',
  unit_feet: 'Piedi',
  unit_meters: 'Metri',
  distance: 'Distanza',
  unit_miles: 'Miglia',
  unit_kilometers: 'Chilometri',
  recent_stations: 'Stazioni recenti',
  clear_recents: 'Cancella recenti',
  currents: 'Correnti',
  nautical_charts: 'Carte nautiche',
  browse_by_country: 'Sfoglia per paese',
  countries_auto: 'Automatico',
  countries_always: 'Sempre',
  countries_never: 'Mai',
  show: 'Mostra',
  hide: 'Nascondi',

  // --- Station pages (tide + current) ---
  tide_title: 'Maree di {{name}}',
  current_title: 'Correnti di {{name}}',
  last_tide: 'Ultima marea',
  next_tide: 'Prossima marea',
  coefficient: 'Coef',
  last_current: 'Corrente precedente',
  next_current: 'Prossima corrente',
  following_current: 'Corrente successiva',
  high: 'Alta',
  low: 'Bassa',
  tides: 'Maree',
  sun: 'Sole',
  moon: 'Luna',
  sunrise_now: 'Alba',
  sunset_now: 'Tramonto',
  moonrise_now: 'Sorgere della luna',
  moonset_now: 'Tramonto della luna',
  sunrise_week: 'Sorgere',
  sunset_week: 'Tramonto',
  moonrise_week: 'Sorgere',
  moonset_week: 'Tramonto',
  add_to_favorites: 'Aggiungi ai preferiti',
  remove_from_favorites: 'Rimuovi dai preferiti',

  // --- Week table dates ---
  today: 'Oggi',
  tomorrow: 'Domani',

  // --- Moon phases ---
  phase_new_moon: 'Luna nuova',
  phase_waxing_crescent: 'Luna crescente',
  phase_first_quarter: 'Primo quarto',
  phase_waxing_gibbous: 'Gibbosa crescente',
  phase_full_moon: 'Luna piena',
  phase_waning_gibbous: 'Gibbosa calante',
  phase_last_quarter: 'Ultimo quarto',
  phase_waning_crescent: 'Luna calante',

  // --- Tide / current status vocabulary ---
  rising: 'In salita',
  falling: 'In discesa',
  high_tide: 'Alta marea',
  low_tide: 'Bassa marea',
  ebb: 'Riflusso',
  flood: 'Flusso',
  slack: 'Stanca',

  // --- Relative time (separate singular/plural keys, native-style) ---
  just_now: 'Adesso',
  somethings_wrong: 'Si è verificato un errore',
  hour_ago: '{{hour}} ora fa',
  hours_ago: '{{hour}} ore fa',
  minute_ago: '{{minute}} minuto fa',
  minutes_ago: '{{minute}} minuti fa',
  hour_minute_ago: '{{hour}} ora, {{minute}} minuto fa',
  hour_minutes_ago: '{{hour}} ora, {{minute}} minuti fa',
  hours_minute_ago: '{{hour}} ore, {{minute}} minuto fa',
  hours_minutes_ago: '{{hour}} ore, {{minute}} minuti fa',
  hour_from_now: '{{hour}} ora da adesso',
  hours_from_now: '{{hour}} ore da adesso',
  minute_from_now: '{{minute}} minuto da adesso',
  minutes_from_now: '{{minute}} minuti da adesso',
  hour_minute_from_now: '{{hour}} ora, {{minute}} minuto da adesso',
  hour_minutes_from_now: '{{hour}} ora, {{minute}} minuti da adesso',
  hours_minute_from_now: '{{hour}} ore, {{minute}} minuto da adesso',
  hours_minutes_from_now: '{{hour}} ore, {{minute}} minuti da adesso',

  // --- Insights ---
  insights_7_day_overview: 'Approfondimenti di 7 giorni',
  no_insights_available: 'Nessun approfondimento disponibile per questa stazione.',
  insights_current_extremes: 'Estremi di corrente',
  insights_fastest_flood: 'Flusso più veloce',
  insights_fastest_ebb: 'Riflusso più veloce',
  insights_strongest_daily_currents: 'Correnti giornaliere di punta',
  insights_fastest_current: 'Più veloce',
  insights_slowest_current: 'Più lenta',
  insights_tidal_extremes: 'Estremi di marea',
  insights_highest_tide: 'Marea più alta',
  insights_lowest_tide: 'Marea più bassa',
  insights_strongest_daily_movements: 'Maggiori ampiezze di marea',
  insights_largest_tide: 'Maggiore',
  insights_smallest_tide: 'Minore',
  insights_value_at_time: '{{value}} alle {{time}}',
  insights_tidal_range_label: 'ampiezza di marea',
  insights_max_current_label: 'corrente massima',

  // --- Insight bands ---
  band_smaller_than_usual: 'Più piccolo del solito',
  band_typical: 'Tipico',
  band_larger_than_usual: 'Più grande del solito',
  band_unusually_large: 'Insolitamente grande',
  band_lower_than_usual: 'Più bassa del solito',
  band_unusually_low: 'Insolitamente bassa',
  band_slower_than_usual: 'Più lenta del solito',
  band_faster_than_usual: 'Più veloce del solito',
  band_unusually_fast: 'Insolitamente veloce',
  band_smaller_than_usual_height: 'Più basso del solito',
  band_larger_than_usual_height: 'Più alto del solito',
  band_unusually_large_height: 'Insolitamente alto',

  // --- Map attribution ---
  attribution: 'Attribuzione',
  attribution_osm: 'Dati della mappa © contributori di OpenStreetMap',
  attribution_tiles: 'Tessere della mappa di OpenFreeMap',
  attribution_style: 'Stile della mappa © OpenMapTiles',
  ok: 'OK',

  // --- Explore map ---
  current_speed: 'Velocità della corrente',
  depth: 'Profondità',
  speed: 'Velocità',
  depth_datum: 'Profondità da',
  depth_drying: 'Secca',
  depth_loading: 'Caricamento dei dati di profondità…',
  depth_datum_tag: 'Profondità in {{unit}} sotto {{datum}}',
  depth_not_for_navigation: 'Non utilizzare per la navigazione.',
  depth_unavailable: 'I dati di profondità non sono disponibili al momento.',
  depth_unit_m: 'm',
  depth_unit_ft: 'ft',
  go_mode_start: 'VAI',
  go_mode_start_label: 'Avvia',
  go_mode_exit: 'Esci',
  go_mode_location_denied:
    "La modalità Go richiede la tua posizione. Attivala tramite l'icona del lucchetto.",
  go_mode_location_denied_ok: 'OK',
  radar: 'Radar',
  radar_precipitation: 'Precipitazioni',
  radar_light: 'debole',
  radar_moderate: 'moderata',
  radar_heavy: 'forte',
  radar_storm: 'violenta',
  radar_forecast: 'previsione',
  radar_none_for_time: 'nessun radar per questo orario',
  now: 'Adesso',
  explore_prompt_denied:
    "La posizione è disattivata per questo sito - abilitala tramite l'icona del lucchetto nella barra degli indirizzi.",
  open_full_map: 'Apri la mappa completa',
  close_full_map: 'Chiudi la mappa completa',
  explore_full_map: 'Esplora la mappa completa',
  center_on_location: 'Centra sulla mia posizione',
  show_my_location: 'Mostra la mia posizione',
  map_knots_label: '{{speed}} kt',

  // --- Location pages ---
  states: 'stati',
  no_stations_found_location: 'Nessuna stazione trovata.',
  tides_and_currents_by_country: 'Maree e correnti per paese',

  // --- SEO titles / descriptions ---
  settings_seo_description: 'Scegli le tue unità per le altezze di marea e le distanze.',
  tide_seo_description:
    'Previsioni delle maree, orari di alta e bassa marea per {{name}}{{location}}.',
  current_seo_description:
    'Previsioni delle correnti di marea, orari di flusso e riflusso per {{name}}{{location}}.',
  location_title: 'Maree e correnti di {{name}}',
  country_seo_description:
    'Orari delle maree e previsioni delle correnti di marea per {{name}}. Sfoglia {{stateTerm}} e stazioni mareografiche costiere in {{name}}.',
  state_seo_description:
    'Previsioni di maree e correnti per {{name}}, {{country}}. Orari di alta e bassa marea per le stazioni costiere in {{name}}.',
  city_seo_description:
    'Orari delle maree e previsioni delle correnti di marea per {{place}}. Maree alte e basse e correnti vicino a {{name}}.',
  // --- Chart pages (chart titles, numbers and purposes stay in the
  // issuing authority's language: they name a specific printed sheet) ---
  charts_for_station: 'Carte nautiche per {{name}}',
  chart_intro:
    'Carta nautica gratuita di {{title}}: profondità rilevate, boe, fanali, scogli, relitti, porti turistici, ancoraggi e stazioni di marea.',
  chart_page_name: 'Carta nautica di {{title}}',
  chart_seo_description:
    'Carta nautica gratuita di {{title}}: profondità rilevate, boe, fanali, scogli, relitti, porti turistici, ancoraggi e stazioni di marea.',

  countries_seo_title: 'Stazioni di marea e di corrente per paese',
  countries_seo_description:
    'Sfoglia le stazioni di marea e di corrente per paese. Orari di alta e bassa marea e previsioni delle correnti di marea per le località costiere di tutto il mondo.',
  home_seo_description:
    'Trova gli orari delle maree e le previsioni delle correnti di marea per le stazioni costiere vicino a te. Consulta alta e bassa marea della tua posizione o sfoglia le stazioni per paese.',
  explore_play: 'Riproduci',
  explore_pause: 'Pausa',
  explore_playback_speed: 'Velocità di riproduzione',
  explore_time: 'Ora',
  skip_to_content: 'Vai al contenuto principale',
  // --- Weather (station pages) ---
  weather: 'Meteo marina',
  wind: 'Vento',
  gusts: 'Raffiche',
  seas: 'Mare',
  time: 'Ora',
  air_temp: 'Aria',
  water_temp: 'Acqua',
  water_temperature: "Temperatura dell'acqua",
  humidity: 'Umidità',
  pressure: 'Pressione',
  precip_chance: 'Precipitazioni',
  chances: 'Probabilità',
  precip_rate: 'Intensità di precipitazione',
  visibility: 'Visibilità',
  condition_thunderstorms: 'Temporali',
  condition_freezing_rain: 'Pioggia gelata',
  condition_sleet: 'Nevischio',
  condition_snow: 'Neve',
  condition_fog: 'Nebbia',
  condition_rain: 'Pioggia',
  condition_cloudy: 'Nuvoloso',
  condition_partly_cloudy: 'Parzialmente nuvoloso',
  condition_clear: 'Sereno',
  weather_thunder: 'Temporale',
  note_seas_computed_from_wind: 'L’altezza del mare è stimata in base a vento e costa.',
  note_seas_from_nearby_open_water: 'Lo stato del mare proviene da acque aperte vicine.',
  note_seas_open_water_nearby:
    "Le onde nelle acque aperte vicine sono di circa {{height}}. Qui l'acqua potrebbe essere più calma.",
  note_seas_open_water_distant:
    "Le onde in acque aperte a {{distance}} sono di circa {{height}}. Qui l'acqua potrebbe essere più calma.",
  note_seas_open_water_distant_dir:
    "Le onde in acque aperte a {{distance}} in direzione {{direction}} da qui sono di circa {{height}}. Qui l'acqua potrebbe essere più calma.",
  note_seas_unavailable: 'Nessuno stato del mare affidabile è disponibile per questo punto.',
  note_sheltered_water_sees_less:
    'Nelle acque riparate il mare è di solito inferiore a questi valori di mare aperto.',
  note_no_warning_feed_coverage:
    'Nessun servizio ufficiale di avvisi marittimi copre questo punto.',
  note_nearest_point_across_land: 'Il punto di previsione più vicino è oltre la terraferma.',
  warnings_none_active: 'Nessun avviso marittimo in vigore',
  warnings_unavailable: 'Gli avvisi marittimi non sono disponibili per questa località',
  warning_show_text: 'Mostra testo ufficiale',
  warning_hide_text: 'Nascondi testo ufficiale',
  weather_updated: 'Aggiornato {{time}}',
  current_conditions: 'Condizioni attuali',
  daily_forecast: 'Previsioni giornaliere',
  expand_for_hourly: 'Espandi per il dettaglio orario',
  hourly: 'Orario',
  hourly_forecast: 'Previsioni orarie',
  wind_speed: 'Velocità del vento',
  wind_gusts: 'Vento e raffiche',
  pressure_humidity: 'Pressione e umidità',
  max_seas: 'Mare massimo',
  visibility_excellent: 'Eccellente',
  visibility_good: 'Buona',
  visibility_moderate: 'Moderata',
  visibility_poor: 'Scarsa',
  forecaster_text_link: 'Testo delle previsioni {{issuer}}',
  temperature: 'Temperatura',
  unit_fahrenheit: 'Fahrenheit',
  unit_celsius: 'Celsius',
  // --- Conditions summary (station pages) ---
  // Sea state: WMO Sea State Code. Wind: Beaufort. Both are published
  // scales with standard terminology in each language, not our own wording.
  // Warning-window and low–high range punctuation. CJK marks a range (and
  // an open end) with ～, not an en dash or a trailing plus.
  warning_window_range: '{{start}} – {{end}}',
  warning_window_open: '{{start}}+',
  range_separator_short: '-',
  // Wave-period fragments. The connector is the locale's own word for the
  // "at" in "0.5 m S @ 3s" (CJK says "period" instead); the value carries
  // the locale's seconds notation (秒/초 — bare Latin "s" reads as an
  // untranslated fragment in CJK weather products).
  seas_period_at: 'a',
  wave_period_short: '{{period}}s',
  // 16-point compass, per this locale’s meteorological convention — the
  // letters differ across languages (Z/O/Ø/V…) and CJK writes the words out.
  compass_N: 'N',
  compass_NNE: 'NNE',
  compass_NE: 'NE',
  compass_ENE: 'ENE',
  compass_E: 'E',
  compass_ESE: 'ESE',
  compass_SE: 'SE',
  compass_SSE: 'SSE',
  compass_S: 'S',
  compass_SSW: 'SSO',
  compass_SW: 'SO',
  compass_WSW: 'OSO',
  compass_W: 'O',
  compass_WNW: 'ONO',
  compass_NW: 'NO',
  compass_NNW: 'NNO',
  // Known warning types, one badge label each. Bureau-home locales use the
  // bureau’s official terminology. Unknown types fall back to the humanized
  // English code in every locale (see warningTypeLabel).
  warning_type_small_craft_advisory: 'Avviso per piccole imbarcazioni',
  warning_type_gale_warning: 'Avviso di burrasca',
  warning_type_gale_watch: 'Preallerta di burrasca',
  warning_type_storm_warning: 'Avviso di tempesta',
  warning_type_storm_watch: 'Preallerta di tempesta',
  warning_type_hurricane_force_wind_warning: 'Avviso di venti di forza uragano',
  warning_type_hurricane_force_wind_watch: 'Preallerta di venti di forza uragano',
  warning_type_special_marine_warning: 'Avviso marittimo speciale',
  warning_type_marine_weather_statement: 'Comunicato meteo marittimo',
  warning_type_hazardous_seas_warning: 'Avviso di mare pericoloso',
  warning_type_brisk_wind_advisory: 'Avviso di vento teso',
  warning_type_low_water_advisory: 'Avviso di acque basse',
  warning_type_dense_fog_advisory: 'Avviso di nebbia fitta',
  warning_type_heavy_freezing_spray_warning: 'Avviso di ghiacciamento da spruzzi',
  warning_type_strong_wind_warning: 'Avviso di vento forte',
  warning_type_gale_force_wind_warning: 'Avviso di burrasca',
  warning_type_storm_force_wind_warning: 'Avviso di tempesta',
  warning_type_wind_warning: 'Avviso di vento',
  warning_type_dense_fog_warning: 'Avviso di nebbia fitta',
  warning_type_icing_warning: 'Avviso di ghiacciamento',
  warning_type_typhoon_warning: 'Avviso di tifone',
  warning_type_wind_wave_warning: 'Avviso di onde alte',
  warning_type_wind_wave_advisory: 'Avviso di moto ondoso',
  warning_type_strong_wind_advisory: 'Preallerta di vento forte',
  warning_type_storm_surge_warning: 'Avviso di marea di tempesta',
  warning_type_storm_surge_advisory: 'Preallerta di marea di tempesta',
  warning_type_thunderstorm_warning: 'Avviso di temporali',
  warning_type_rough_sea_warning: 'Avviso di mare agitato',
  warning_type_fog_warning: 'Avviso di nebbia',
  sea_state_calm_rippled: 'Mare increspato',
  sea_state_smooth: 'Mare quasi calmo',
  sea_state_slight: 'Mare poco mosso',
  sea_state_moderate: 'Mare mosso',
  sea_state_rough: 'Mare molto mosso',
  sea_state_very_rough: 'Mare agitato',
  sea_state_high: 'Mare molto agitato',
  sea_state_very_high: 'Mare grosso',
  sea_state_phenomenal: 'Mare tempestoso',
  hazard_showers: 'Rovesci',
  hazard_reduced_visibility: 'Visibilità ridotta',
  hazard_haze: 'Foschia',
  hazard_waterspout: 'Trombe marine',
  hazard_freezing_spray: 'Spruzzi ghiaccianti',
  hazard_ice: 'Ghiaccio',
  marine_summary_sea_wind: '{{sea}}, vento da {{direction}} a {{speed}}.',
  marine_summary_wind_only_gusting: 'Vento da {{direction}} a {{speed}}, raffiche {{gust}}.',
  marine_summary_sea_wind_gusting:
    '{{sea}}, vento da {{direction}} a {{speed}}, raffiche {{gust}}.',
  marine_summary_wind_only: 'Vento da {{direction}} a {{speed}}.',
  marine_summary_sea_only: '{{sea}}.',
  marine_prediction_caveat_tide_one:
    'Le previsioni di marea sono astronomiche, quindi il tempo di quell’avviso può alzare o abbassare il livello reale.',
  marine_prediction_caveat_tide_many:
    'Le previsioni di marea sono astronomiche, quindi il tempo di quegli avvisi può alzare o abbassare il livello reale.',
  marine_prediction_caveat_current_one:
    'Le previsioni di corrente sono astronomiche, quindi il tempo di quell’avviso può rinforzare o indebolire la corrente reale.',
  marine_prediction_caveat_current_many:
    'Le previsioni di corrente sono astronomiche, quindi il tempo di quegli avvisi può rinforzare o indebolire la corrente reale.',
  marine_warning_active: 'È in vigore un avviso per la navigazione in questa zona.',
  marine_warnings_active: 'Sono in vigore avvisi per la navigazione in questa zona.',
  marine_warning_upcoming:
    'Un avviso per la navigazione entra in vigore in questa zona il {{time}}.',
  marine_warnings_upcoming:
    'Gli avvisi per la navigazione entrano in vigore in questa zona dal {{time}}.',
  marine_summary_hazard_now: 'In questo momento: {{hazard}}.',
  marine_summary_hazard_later: 'Nelle previsioni: {{hazard}}.',
  marine_tide_rising:
    'La marea è a {{height}} e sta salendo: prossima alta marea {{next}} alle {{time}}.',
  marine_tide_falling:
    'La marea è a {{height}} e sta scendendo: prossima bassa marea {{next}} alle {{time}}.',
  marine_current_flood: 'Prossima corrente montante {{speed}} alle {{time}}.',
  marine_current_ebb: 'Prossima corrente calante {{speed}} alle {{time}}.',
  marine_current_slack: 'Prossimo stanca alle {{time}}.',
  marine_current_now_flood: 'La corrente è montante a {{speed}}.',
  marine_current_now_ebb: 'La corrente è calante a {{speed}}.',
  marine_current_now_slack: 'La corrente è stanca.',
  marine_current_peak: 'Massimo {{speed}} alle {{time}}.',

  // --- Chart furniture (navaid / hazard / POI click popups) ---
  // See en.js for the rules these follow. "IALA A" / "IALA B" stay untranslated
  // in every language: it is the standard's name.
  furn_light: 'Fanale',
  furn_buoy: 'Boa',
  furn_beacon: 'Meda',
  furn_wreck: 'Relitto',
  furn_rock: 'Scoglio',
  furn_obstruction: 'Ostruzione',
  furn_anchorage: 'Ancoraggio',
  furn_tss: 'Schema di separazione del traffico',
  furn_routing: 'Organizzazione del traffico',
  furn_title_buoy: 'Boa {{category}}',
  furn_title_beacon: 'Meda {{category}}',
  furn_cat_port: 'di sinistra',
  furn_cat_starboard: 'di dritta',
  furn_cat_preferred_channel_port: 'di canale preferenziale a sinistra',
  furn_cat_preferred_channel_starboard: 'di canale preferenziale a dritta',
  furn_cat_safe_water: 'di acque sicure',
  furn_cat_isolated_danger: 'di pericolo isolato',
  furn_cat_north: 'cardinale Nord',
  furn_cat_east: 'cardinale Est',
  furn_cat_south: 'cardinale Sud',
  furn_cat_west: 'cardinale Ovest',
  furn_cat_special: 'speciale',
  furn_cat_mooring: 'di ormeggio',
  furn_cat_lateral: 'laterale',
  furn_characteristic: 'Caratteristica',
  furn_range: 'Portata',
  furn_height: 'Altezza',
  furn_colour: 'Colore',
  furn_shape: 'Forma',
  furn_lights_on_mark: 'Luci su questo segnale',
  furn_topmark: 'Miraglio',
  furn_class: 'Classe',
  furn_least_depth_over: 'Profondità minima sopra',
  furn_depth_over: 'Profondità sopra',
  furn_state: 'Stato',
  furn_type: 'Tipo',
  furn_range_value: '{{value}} M',
  furn_metres_value: '{{value}} m',
  furn_cable: 'Cavo sottomarino',
  furn_pipeline: 'Condotta sottomarina',
  furn_restricted_area: 'Zona regolamentata',
  furn_restriction: 'Restrizione',
  furn_mpa: 'Area marina protetta',
  furn_protection: 'Protezione',
  furn_agency: 'Gestita da',
  furn_mpa_note: 'Una designazione di conservazione, non una restrizione alla navigazione.',
  furn_sector: 'Settore',
  furn_sector_value: '{{from}}° → {{to}}°',
  lightw_f: 'Luce {{colour}} fissa.',
  lightw_fl: 'Lampeggia in {{colour}} ogni {{period}} secondi.',
  lightw_fl_group: 'Lampeggia in {{colour}} a gruppi di {{count}}, ogni {{period}} secondi.',
  lightw_lfl: 'Un lampo lungo {{colour}} ogni {{period}} secondi.',
  lightw_q: 'Lampeggio {{colour}} rapido.',
  lightw_iso: 'Luce {{colour}} e buio uguali, ogni {{period}} secondi.',
  lightw_oc: 'Luce {{colour}} fissa con breve eclisse ogni {{period}} secondi.',
  lightcolour_white: 'bianca',
  lightcolour_red: 'rossa',
  lightcolour_green: 'verde',
  lightcolour_yellow: 'gialla',
  furn_feet_charted_value: '{{feet}} ft ({{metres}} m in carta)',
  furn_light_yes: 'sì',
  furn_shown_neutral: '{{colours}} (mostrato in neutro)',
  furn_note_light: 'Aspetto della luce di notte: il navigante la identifica così.',
  furn_note_lateral_b_port:
    'Segna il lato SINISTRO del canale rientrando dal mare (IALA B: cilindrica verde).',
  furn_note_lateral_b_starboard:
    'Segna il lato DESTRO del canale rientrando dal mare (IALA B: “rosso a destra rientrando”).',
  furn_note_lateral_a_port:
    'Segna il lato di SINISTRA del canale entrando dal mare (IALA A: rosso a sinistra).',
  furn_note_lateral_a_starboard:
    'Segna il lato di DRITTA del canale entrando dal mare (IALA A: verde a dritta).',
  furn_note_safe_water:
    'Acque sicure tutto intorno, di solito il segnale di atterraggio o di mezzo canale.',
  furn_note_isolated_danger: 'Ormeggiata sopra un pericolo isolato con acque navigabili intorno.',
  furn_note_cardinal_north: 'Segnale cardinale: passare a NORD.',
  furn_note_cardinal_east: 'Segnale cardinale: passare a EST.',
  furn_note_cardinal_south: 'Segnale cardinale: passare a SUD.',
  furn_note_cardinal_west: 'Segnale cardinale: passare a OVEST.',
  furn_note_special: 'Segnale speciale (giallo): limiti, cavi, ormeggi, regate.',
  furn_note_preferred_starboard: 'Segnale di biforcazione: il canale preferito è a dritta.',
  furn_note_preferred_port: 'Segnale di biforcazione: il canale preferito è a sinistra.',
  furn_note_mooring: 'Boa di ormeggio.',
  furn_vessel: 'Nave',
  furn_depth_quality: 'Qualità del fondale',
  furn_length: 'Lunghezza',
  furn_position_accuracy: 'Precisione della posizione',
  furn_remarks: 'Note',
  furn_circumstances: 'Circostanze',
  furn_status: 'Stato',
  furn_note_shom: 'Cartografato dallo Shom (Francia). ©Shom, CC BY-SA 4.0.',
  furn_lock: 'Chiusa',
  furn_bridge: 'Ponte',
  furn_overhead_cable: 'Cavo aereo',
  furn_notice_mark: 'Segnale di avviso',
  furn_distance_mark: 'Segnale di distanza',
  furn_daymark: 'Segnale diurno',
  furn_channel: 'Canale',
  furn_vertical_clearance_closed: 'Altezza libera (chiuso)',
  furn_vertical_clearance_open: 'Altezza libera (aperto)',
  furn_datum: 'Riferimento',
  furn_datum_value: '{plane} (VERDAT {code})',
  furn_datum_unknown: 'unknown code (VERDAT {code})',
  furn_note_ienc:
    "ENC fluviale (US Army Corps of Engineers). Le altezze libere sono misurate sopra il piano di riferimento indicato; con il fiume in piena l'altezza reale è minore.",
  furn_note_wreck: 'Relitto cartografato. Le profondità sono valori di carta, non verificati.',
  furn_note_anchorage: 'Zona di ancoraggio cartografata.',
  furn_note_tss:
    'Corsie di navigazione a senso unico. Le piccole imbarcazioni le attraversano ad angolo retto e si tengono libere.',
  furn_route: 'Rotta',
  furn_fairway: 'Canale navigabile',
  furn_recommended_track: 'Rotta raccomandata',
  furn_navigation_line: 'Linea di navigazione',
  furn_leading_line: 'Allineamento',
  furn_clearing_line: 'Linea di sicurezza',
  furn_transit_line: 'Linea di transito',
  furn_traffic: 'Traffico',
  furn_orientation: 'Orientamento',
  furn_degrees_value: '{{value}}°',
  furn_note_fairway: 'Canale riportato sulla carta: il passaggio mantenuto o preferenziale.',
  furn_note_track: 'Linea di rotta riportata sulla carta.',
  furn_note_track_fixed_marks:
    'Linea di rotta riportata sulla carta, basata su punti cospicui fissi (allineamenti).',
  furn_note_leading_line:
    'Mantenga allineati i segnali per restare sulla linea riportata sulla carta.',
  furn_note_navigation_line: 'Linea di navigazione riportata sulla carta.',
  furn_poi_marina: 'Marina',
  furn_poi_fuel: 'Carburante',
  furn_poi_slipway: 'Scivolo di alaggio',
  furn_poi_ferry_terminal: 'Terminal traghetti',
  furn_poi_boatyard: 'Cantiere navale',
  furn_poi_lighthouse: 'Faro',
  furn_note_slipway: 'Scivolo di alaggio.',
  // Layers sheet — UNTRANSLATED, English placeholders (2026-09-11). Catalog
  // parity is enforced by scripts/check-locale-keys.mjs, so a key cannot be
  // added to en.js alone; these are placeholders awaiting translation, not
  // a claim that the strings are localized.
  layers: 'Layers',
  layers_close: 'Close layers',
  layers_map_type: 'Map type',
  layers_visualizations: 'Visualizations',
  layers_standard_map: 'Standard Map',
  layers_depth_chart: 'Depth Chart',
  layers_moving_tides: 'Moving Tides',
  layers_moving_currents: 'Moving Currents',
  layers_wind_waves: 'Wind & Waves',
  layers_weather_radar: 'Weather Radar',
  layers_coming_soon: 'Coming soon',
  layers_no_currents_here: 'No current stations in view',
  layers_no_radar_here: 'No radar coverage in view',
  // The compass button's accessible name. {{point}} is a 16-point direction
  // (SSW) and {{deg}} the exact bearing — the face rounds to 8 points, this
  // does not. English placeholder in the non-English catalogs, awaiting
  // translation; catalog parity is enforced by scripts/check-locale-keys.mjs.
  follow_my_direction: 'Segui il mio orientamento',
  compass_faces: 'Map faces {{point}} · {{deg}}°, tap for north-up',
  ww_row_no_data: '{{row}}: nessun dato qui',
  ww_row_no_forecast_after: '{{row}}: nessuna previsione dopo {{when}}',
  ww_row_no_forecast: '{{row}}: nessuna previsione così in avanti',
  ww_unavailable: 'Meteo non disponibile',
  explore_show_player: 'Mostra la cronologia',
  explore_hide_player: 'Nascondi la cronologia',

  // --- Route planning on /explore (2026-10-23) ---
  // Describe, never advise; never "safe". The service's own disclaimer is
  // printed verbatim from its response; route_disclaimer is only the fallback.
  // Mark nouns are all feminine (boa, meda) so colour, "la" and "luminosa"
  // agree; a US "light" is a meda luminosa here.
  route_plan: 'Pianifica una rotta',
  route_leave: 'Esci dalla pianificazione della rotta',
  route_title: 'Rotta',
  route_prompt_start: "Tocca l'acqua da cui partirai.",
  route_prompt_start_desktop: "Fai clic sull'acqua da cui partirai, poi sulla destinazione.",
  route_prompt_end: 'Partenza impostata. Ora tocca la destinazione.',
  route_prompt_end_desktop: 'Partenza impostata. Ora fai clic sulla destinazione.',
  route_drag_hint: 'I segnaposto si possono trascinare.',
  route_clear: 'Cancella',
  route_swap: 'Inverti partenza e destinazione',
  route_share: 'Copia link',
  route_copied: 'Link copiato',
  route_start: 'Partenza',
  route_destination: 'Destinazione',
  route_near: 'vicino a {{name}}',
  route_loading: 'Calcolo della rotta…',
  route_loading_sub: 'Di solito un secondo o due. Alcune zone richiedono fino a 30 secondi.',
  route_loading_slow: 'Ancora in corso…',
  route_loading_slow_sub: 'Questa zona richiede più tempo del solito.',
  route_summary_time: '{{duration}} a {{speed}}',
  route_planning_speed: 'Velocità di pianificazione',
  route_shoalest: 'Profondità minima sulla rotta',
  route_planning_draft: 'pescaggio di pianificazione',
  route_change: 'modifica',
  route_draft_title: 'Pescaggio di pianificazione',
  route_draft_help:
    'La profondità per cui è pianificata la rotta, non il pescaggio della tua barca. Più profondo trova meno passaggi; meno profondo ne trova di più.',
  route_datum: 'Profondità riferite allo zero idrografico (MLLW), senza marea applicata.',
  route_unassured_note:
    'I tratti arancioni attraversano acque che la carta e i rilievi non risolvono sotto {{draft}}.',
  route_row_start: 'Partenza {{label}}',
  route_row_heading: 'rotta {{course}}° ({{point}})',
  route_row_end: 'Arrivo {{label}}',
  route_row_end_sub: 'fine della rotta',
  route_turn_left: 'Accosta a sinistra per {{course}}°',
  route_turn_right: 'Accosta a destra per {{course}}°',
  route_bear_left: 'Accosta leggermente a sinistra per {{course}}°',
  route_bear_right: 'Accosta leggermente a destra per {{course}}°',
  route_then: '{{first}}, poi {{second}}',
  route_keep_mark: 'Lascia la {{mark}} alla tua {{hand}}',
  route_leave_channel: 'Esci dal canale alla {{mark}}',
  route_on_your: 'alla tua {{hand}} (lato di {{side}})',
  route_hand_left: 'sinistra',
  route_hand_right: 'destra',
  route_side_port: 'sinistra',
  route_side_starboard: 'dritta',
  route_mark_buoy: 'boa {{color}} {{num}}',
  route_mark_light: 'meda luminosa {{color}} {{num}}',
  route_mark_daybeacon: 'meda {{color}} {{num}}',
  route_mark_lighted: '{{mark}} (luminosa)',
  route_red: 'rossa',
  route_green: 'verde',
  route_follow: 'Segui {{name}}',
  route_follow_two: 'Segui {{first}}, poi {{second}}',
  route_follow_channel: 'il canale {{name}}',
  route_follow_named: 'il {{name}}',
  route_follow_unnamed: 'il canale segnalato',
  route_follow_marks: '{{count}} segnali',
  route_greens_on: 'verdi alla tua {{hand}}',
  route_reds_on: 'rosse alla tua {{hand}}',
  route_show_marks: 'Mostra i segnali',
  route_hide_marks: 'Nascondi i segnali',
  route_why: 'Perché accosta qui?',
  route_turn_reason: 'Accosta qui perché {{reason}}',
  route_lights: 'Fanali in portata: {{lights}}',
  route_stretch_unassured: 'profondità non risolta sotto {{draft}}',
  route_stretch_rocky: 'tra scogli segnati in carta',
  route_stretch_canal:
    'canale: manovra delle chiuse, porte e altezza libera dei ponti non modellate',
  route_step_of: 'Tappa {{n}} di {{total}}',
  route_all_steps: 'Tutte le tappe',
  route_prev_step: 'Tappa precedente',
  route_next_step: 'Tappa successiva',
  route_minutes: '{{n}} min',
  route_hours: '{{h}} h',
  route_hours_minutes: '{{h}} h {{m}} min',
  route_err_on_land_origin: 'La partenza è su terraferma in carta',
  route_err_on_land_destination: 'La destinazione è su terraferma in carta',
  route_err_on_land_origin_sub:
    'Trascina il segnaposto di partenza in acqua. Una palude, una spiaggia o un pontile contano come terra sulla carta.',
  route_err_on_land_destination_sub:
    'Trascina il segnaposto di destinazione in acqua. Una palude, una spiaggia o un pontile contano come terra sulla carta.',
  route_err_no_route: 'Nessuna rotta con un pescaggio di pianificazione di {{draft}}',
  route_err_no_route_sub:
    'In qualche punto tra i due la carta indica meno di {{draft}}. Un pescaggio di pianificazione minore potrebbe trovare un passaggio.',
  route_err_no_snap: 'Nessuna acqua in carta vicino a uno dei punti',
  route_err_no_snap_sub: 'Avvicina i segnaposto ad acque aperte.',
  route_err_outside: 'Per ora la pianificazione della rotta copre le acque degli Stati Uniti',
  route_err_outside_sub:
    'Le rotte sono costruite sulle carte NOAA, quindi entrambi i punti devono essere in acque degli Stati Uniti. Altre coste in seguito.',
  route_err_timeout: 'Il servizio rotte ha impiegato troppo tempo',
  route_err_timeout_sub:
    'Alcune zone richiedono fino a 30 secondi e questa ha superato il tempo limite.',
  route_err_unavailable: 'La pianificazione della rotta non è disponibile al momento',
  route_err_unavailable_sub: 'Riprova tra un momento.',
  route_err_busy: 'Troppe richieste di rotta',
  route_err_busy_sub: 'Attendi un minuto e riprova.',
  route_try_again: 'Riprova',
  route_disclaimer:
    "Non per la navigazione. Questa rotta segue il canale segnalato come riportato in carta; non è un'affermazione di acque sicure.",
  route_promo_title: "Segui questa rotta nell'app con la modalità Go",
  route_promo_body:
    'La modalità Go tiene la tua barca sulla carta con la distanza dal prossimo segnale o dalla prossima accostata, la profondità sotto di te e la marea e la corrente della stazione più vicina. In Tides Near Me per iPhone e Android, con un abbonamento.',
}
